/**
 * Sign-in.
 *
 * Pressentia issues its own identities: this posts to the Pressentia API and gets back a token the same
 * API verifies. There is no second service in the path and no other product's user list involved.
 */

import { apiPost } from 'src/api/client';
import type { SessionEditor } from 'src/lib/session';

type SignInResponse = {
  token: string;
  user: { userId: string; name: string; email: string; role: string };
};

export async function signIn(email: string, password: string): Promise<{ token: string; editor: SessionEditor }> {
  const { token, user } = await apiPost<SignInResponse>('/auth/sign-in', { email: email.trim(), password });
  return { token, editor: { name: user.name, email: user.email } };
}
